import { Container, Grid } from '@material-ui/core';
import React from 'react';
import './info.scss';

export const Info: React.FC = () => (
  // <></> // todo: omment all below and uncomment this line to remove the info banner

  // todo: Use the code below to display the clearing the cache banner only on a gray banner
  <div className="">
    <Container className="info-bar__container">
      <Grid
        container
        item
        xs={12}
        sm={12}
        md={12}
      >
        <p>If you are experiencing delays in returning search results, please try
          <a
            href="https://www.sheepgenetics.org.au/globalassets/sheep-genetics/resources/brochures-and-fact-sheets/clearing-the-cache.pdf"
            target="_blank"
            rel="noreferrer"
          > clearing the cache
          </a>.
        </p>
      </Grid>
    </Container>
  </div>

  // todo: If we want to display Important message we use the below code to set the orange banner
  // <div className="sg-info-bar">
  //   <Container className="info-bar__container">
  //     <Grid
  //         container
  //         item
  //         xs={12}
  //         sm={12}
  //         md={12}
  //     >
  //       <h4>
  //         <br/>Please note we are aware of an issue with missing index information for the <strong>Maternal
  //         analysis</strong>.
  //         We are working on fixing this. Results will be updated when this is resolved.<br/>
  //       </h4>
  //       <p>If you are experiencing delays in returning search results, please try
  //         <a
  //             href="https://www.sheepgenetics.org.au/globalassets/sheep-genetics/resources/brochures-and-fact-sheets/clearing-the-cache.pdf"
  //             target="_blank"
  //             rel="noreferrer"
  //         > clearing the cache
  //         </a>.
  //       </p>
  //     </Grid>
  //   </Container>
  // </div>
);
